export type PlanCode = string;

export type Plan = {
  code: PlanCode;
  name: string;
  tagline?: string;
  priceLabel?: string; // Display only; backend controls pricing
  features?: string[];
};

function titleCase(code: string) {
  return code
    .toLowerCase()
    .replace(/(^|_|-)([a-z])/g, (_m, _p1, c) => c.toUpperCase())
    .replace(/_/g, " ");
}

export function getAvailablePlanCodes(): PlanCode[] {
  const env = (import.meta as any)?.env || {};
  const raw = env.VITE_AVAILABLE_PLAN_CODES as string | undefined;
  if (raw && raw.trim().length > 0) {
    return raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }
  // Sensible defaults
  return ["STUDIO", "ATELIER", "COUTURE"];
}

export function getPlans(): Plan[] {
  const codes = getAvailablePlanCodes();
  // Entitlement bullets per plan. Keep in sync with backend caps shown to users.
  // Reason: Marketing display should reflect typical wardrobe limits without exposing backend internals.
  const entitlementMap: Record<string, string[]> = {
    STUDIO: [
      "Up to 20 outfits",
      "Closet up to 30 items",
      "AI outfit image generation",
    ],
    ATELIER: [
      "Up to 50 outfits",
      "Closet up to 60 items",
      "AI outfit image generation",
    ],
    COUTURE: [
      "Up to 80 outfits",
      "Closet up to 100 items",
      "AI outfit image generation",
    ],
  };

  return codes.map((code) => ({
    code,
    name: titleCase(code),
    // Keep labels minimal; actual pricing comes from Stripe checkout
    priceLabel: undefined,
    features: entitlementMap[code] || ["AI outfit image generation"],
  }));
}
